export enum DispatcherCapabilityType {
  ManageDriverMedicalNorms = 'ManageDriverMedicalNorms',
  ManageDriverHealthCertificates = 'ManageDriverHealthCertificates',
  RestoreDismissedDrivers = 'RestoreDismissedDrivers',
  UnlinkDriverHidCards = 'UnlinkDriverHidCards',
  BulkUpdateDriverMedicalNorms = 'BulkUpdateDriverMedicalNorms',
  ManageDriverPersonalData = 'ManageDriverPersonalData',
}

export const dispatcherCapabilityClaim: Record<DispatcherCapabilityType, string> = {
  [DispatcherCapabilityType.ManageDriverMedicalNorms]: 'manage-driver-medical-norms',
  [DispatcherCapabilityType.ManageDriverHealthCertificates]: 'manage-driver-health-certificates',
  [DispatcherCapabilityType.RestoreDismissedDrivers]: 'restore-dismissed-drivers',
  [DispatcherCapabilityType.UnlinkDriverHidCards]: 'unlink-driver-hid-cards',
  [DispatcherCapabilityType.BulkUpdateDriverMedicalNorms]: 'bulk-update-driver-medical-norms',
  [DispatcherCapabilityType.ManageDriverPersonalData]: 'manage-driver-personal-data',
};
